'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { Box } from '@mui/material';
import { useNetworkStatus } from '../../utilities/hooks/useNetworkStatus';
import { NetworkBanner } from './NetworkBanner';
const NetworkStatusContext = React.createContext<ReturnType<typeof useNetworkStatus> | null>(null);

/**
 * Provides global network status and renders the offline/unstable connection banner.
 */
export function NetworkStatusProvider(t0) {
  const $ = _c(14);
  const {
    children
  } = t0;
  const networkStatus = useNetworkStatus();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      flexDirection: "column",
      height: "100dvh",
      minHeight: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== networkStatus.isConnectionUnstable || $[2] !== networkStatus.isOnline || $[3] !== networkStatus.isSlowConnection) {
    t2 = <NetworkBanner isOnline={networkStatus.isOnline} isConnectionUnstable={networkStatus.isConnectionUnstable} isSlowConnection={networkStatus.isSlowConnection} />;
    $[1] = networkStatus.isConnectionUnstable;
    $[2] = networkStatus.isOnline;
    $[3] = networkStatus.isSlowConnection;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      minHeight: 0
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== children) {
    t4 = <Box sx={t3}>{children}</Box>;
    $[6] = children;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <Box sx={t1}>{t2}{t4}</Box>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== networkStatus || $[12] !== t5) {
    t6 = <NetworkStatusContext.Provider value={networkStatus}>{t5}</NetworkStatusContext.Provider>;
    $[11] = networkStatus;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}

/**
 * Reads global network status from {@link NetworkStatusProvider}.
 */
export function useNetworkStatusContext() {
  const context = React.useContext(NetworkStatusContext);
  if (!context) {
    throw new Error("useNetworkStatusContext must be used within NetworkStatusProvider");
  }
  return context;
}